module.exports = __webpack_public_path__ + "static/media/21ECLAC51.0fcff2b1.jpg";